import React, { useState } from "react";
import { Row, FormControl, InputGroup } from "react-bootstrap";
import { queryStringToHash, updateQueryString } from "./lib/utils";
import { useUpdateEffect } from './lib/customHooks';
import debounce from "lodash/debounce";

const style = Object.freeze({ maxWidth: 150 });

export const rejectEmptyValue = obj =>
  Object.keys(obj)
    .filter(k => obj[k] !== undefined)
    .reduce((acc, k) => ({ ...acc, [k]: obj[k] }), {});

const SearchInput = props => {
  const [values, setValues] = useState({ [props.name]: props.value || '' });
  const [jqxhr, setJqxhr] = useState(null);

  const fetch = debounce((q) => {
    if (jqxhr) {
      jqxhr.abort();
    }

    updateQueryString(rejectEmptyValue(q));

    const options = {
      type: 'GET',
      url: props.url,
      data: { ...queryStringToHash(), ...rejectEmptyValue(q) }
    };

    setJqxhr($.ajax(options));
  }, 500);

  const handleChange = e => {
    e.persist();
    setValues(old => ({ ...old, [e.target.name]: e.target.value }));
  };
  console.log(values);

  useUpdateEffect(() => { fetch(values); }, [values]);

  return (
    <InputGroup className="align-items-center">
      <InputGroup.Text>{props.label}</InputGroup.Text>
      <FormControl
        type="text"
        placeholder={props.placeholder || ''}
        style={style}
        name={props.name}
        value={values[props.name]}
        onChange={handleChange} />
    </InputGroup>
  );
}

export default SearchInput;
